
<div class="row justify-content-md-center no-gutters greyBgBody marL10">
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 additionalQuestionSection whiteBg text-center">
                <h5 class="sectionTitleBig">Data Clean Up</h5>
                <div class="col-8 display_inlineBlock text-center">
                    <div class="col-10 display_inlineBlock">
                        <!-- <input type="text" class="form-control" [(ngModel)]="emailIdUserName" placeholder="Enter email or Username" name="userName" /> -->
                        <div class="display_flex">
                            <textarea
                            [(ngModel)]="emailIdUserName"
                            (keyup)="validateEmails()"
                            class="form-control"
                            [ngClass]="{'error-box': invalidEmailFormat}"
                            placeholder="Enter email(s)"
                            ></textarea>
                    
                        <span class="infoIconSmall-ProposedSubs"
                            title="Enter or copy and paste email addresses into the box using semicolon (do not include spaces)."></span>
                        </div>
                        <!-- <div *ngIf="invalidEmailFormat" class="error-text">
                            Enter a valid Deloitte email. 
                        </div> -->
                    </div>
                    <div class="row dataCleanUpRadioBtns justify-content-md-center" [ngClass]="{'removeClass': currentRole == 3}">
                        <!--<input #updateMobile type="radio" name="dataCleanUpType" [checked]="radioUpdateNo" (click)="onRadioBtnClick('updateMobile')" id="updateMobile" /> <label for="updateMobile">Update Mobile Number</label>-->
                      <div class="col-4 d-flex align-items-center justify-content-md-center">
                        <input #maskUser class="me-2" type="radio" name="dataCleanUpType" [checked]="radioMask" (click)="onRadioBtnClick('mask')" id="maskUser" /> <label class="mb-0 no_wrap" for="maskUser">Mask User</label>
                      </div>
                      <div class="col-4 d-flex align-items-center justify-content-md-center" *ngIf="currentRole != 3">
                        <input #resetIncompleteAssessment class="me-2" type="radio" [disabled]="disableReset || currentRole == 3" [checked]="radioReset" name="dataCleanUpType" (click)="onRadioBtnClick('reset')" id="resetIncompleteAssessment" /> <label class="mb-0 no_wrap" for="resetIncompleteAssessment">Reset Incomplete Assessment</label>
                      </div>
                    </div>
                    <div class="">
                        <button type="submit" [disabled]="isSearchDisable" (click)="onSubmitBtnClick()" class="clickBtn">Submit</button>
                    </div>
                    <div *ngIf="validateUser" [style.color]="'red'">User does not exist.</div>
                </div>
                <div class="dataCleanUpUserDetailArea col-12">
                    <div>{{successMessageText}}</div>
                    <div></div>
                    <div class="row">
                        <h5 class="sectionTitleBig" *ngIf="showUserDetails">User Details</h5>
                        <div class="searchDataTable table_overflow" *ngIf="showUserDetails" [style.max-height]="searchGridHeight">
                            <app-smart-data-grid [sampleColumns]="userGridColumns" [sampleData]="userGridData" [allowCheckbox]="allowRowCheckboxInGrid"
                                [iseventRegistered]="iseventRegistered" [allowPagination]="allowPagination"
                                [isClientSidePagination]="isClientSidePagination"
                                [totalRecord]="totalRecordUserGrid" [pageSize]="100"></app-smart-data-grid>
                        </div>
                    </div>
                    <!-- <h5 class="sectionTitleBig">User Details</h5>
                    <div class="row">
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="firstName" placeholder="First Name" name="firstName" /></div>
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="lastName" placeholder="Last Name" name="lastName" /></div>
                    </div>
                    <div class="row">
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="countryName" placeholder="Country/Location" name="countLocation" /></div>
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="functionName" placeholder="Function" name="function" /></div>
                    </div>
                    <div class="row">
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="industry" placeholder="Industry" name="industry" /></div>
                        <div class="col"><input type="text" disabled class="form-control col" [(ngModel)]="position" placeholder="Position" name="position" /></div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <select class="form-control custom-select" [disabled]="isDisabledMobileNo" [(ngModel)]="selectedCountryCodeId" id="select-" name="">
                                    <option value="undefined">Code</option>
                                    <option *ngFor="let item  of countries" value={{item.countryCodeId}}>{{(item.name + ' ( + ' + (item.countryCode) + ' )')}}</option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                            </div>

                        </div>
                        <div class="col"><input type="text" onkeypress="javascript:return (event.charCode >= 48 && event.charCode <= 57) || event.charCode==45"  class="form-control col" [disabled]="isDisabledMobileNo" [(ngModel)]="mobileNumber" placeholder="Mobile Number" name="Mobile" /></div>
                    </div>-->

                    <div class="mask_resetBtn" *ngIf="showUserDetails">
                        <button type="submit" *ngIf="validateUser !== undefined" [disabled]="!maskDisable" (click)="onUpdateMaskReset()" class="clickBtn">{{updateBtnText}}</button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>
